// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }
const spImgList = [
  'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1y_29d1587d-8653-48ae-921f-f9572726aefd.png?v=1764669362',
  'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1j_731b9473-0313-4dbb-89b0-3c25488ce3c6.png?v=1764669361',
  
  'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1h_0b63ca18-b73e-435b-9f25-ce7f2db1319a.png?v=1764669362',
  "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1j_1_3.png?v=1764669362",
  "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1j_1.png?v=1764669362",
  "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/1j_1_2.png?v=1764669362",
    'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/2j.png?v=1743673407',
  'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/2h.png?v=1743673407',

  'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/2y.png?v=1743673407',
    'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/3j.png?v=1743673407',
  'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/3h.png?v=1743673406',

  'https://cdn.shopify.com/s/files/1/0745/9871/1599/files/3y.png?v=1743673408',
]
  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  $('.sp-button').click(function () {
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':1'
  })

  $('.sp-cart-box').click(function () {
    $('.c_toast').show()
    setTimeout(function () {
      $('.c_toast').hide()
    }, 1200)
    let number = Number($('.sp-header-top .sp-cart .num').html())
    $('.sp-header-top .sp-cart .num').html(number + 1)
    var data = {
      id: $(this).attr('data-id'),
      quantity: 1,
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $("#cardNum").html(result.item_count);
        })
      },
      dataType: 'json',
    })
  })
   let prods = window.product
function getCur() {
  let color = $('.sp-color div.active').attr('data-val')

  return prods.filter(item => item.option1 == color )[0]
}
function changePrice() {
  let num = $('#calcNumber').val()
  let price = ((getCur().price * num) / 100).toFixed(2)
  let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
  let off_font =
    100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
  $('.product-part .sp-padding .off').html(off_font)
  price = (price + '')
  compare = (compare + '')
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
}

$('.sp-reduce').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) - 1
  if (num > 0) {
    input.value = num
    changePrice()
  }
})
$('.sp-add').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) + 1
  input.value = num
  changePrice()
})

$('.sp-option').click(function () {
  $(this).siblings().removeClass('active')
  $(this).addClass('active')
  let colorOptions = $('.sp-color .sp-option.active').index()
  // let numOptions = $('.sp-num .sp-option.active').index()

  let _index = colorOptions
  $('.product-part .p-img')[0].src = spImgList[_index]
  changePrice()
})
$('.sp-btn-style').click(function () {
  console.log('1111')
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
$('.addCart').click(function () {
  var data = {
    id: getCur().id,
    quantity: $('#calcNumber').val(),
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    success: function () {
      $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
        $('#cardNum').html(result.item_count)
      })
    },
    dataType: 'json',
  })
})
  $('.product-part .cart-btn').click(function () {
    var img = $('.product-part .p-img')
    // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

    var flyer = img[0].cloneNode(true)
    flyer.classList.add('sp_clone')

    $('.product-part').append(flyer)
    $('.sp_clone').css({
      width: img[0].width,
      height: img[0].height,
      background: '#e7e9ef',
      position: 'fixed',
      top: img[0].offsetTop,
      left: img.offset().left,
      'z-index': '99',
    })

    let finish = $('.sp-cart')
    $('.sp_clone').animate(
      {
        // top: finish[0].offsetTop,
        top: finish[0].offsetTop + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach()
          }
        )
      }
    )
  })
  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            260 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
